<template>
    <div class="user-avatar"
         :class=" [frameClass , profClass, imageSourceClass, (useCustomPhoto.value ? 'custom-photo' : 'avatar') ].join(' ') ">
        <div class="avatar">
            <img
            :src=" userAvatar "
            :alt="'Avatar de l\'utilisateur ' + userName">
        </div>

        <div class="frame" v-if=" ! authorIsProf &&  userFrame !== '' "><img
            :src=" userFrame "
            :alt="'Cadre d\'avatar de l\'utilisateur ' + userName "></div>
    </div>
</template>

<script setup>
import { onMounted, computed } from 'vue';

import { useStore } from "vuex";

let store    = useStore();
let copydeck = computed( () => store.state.copydeck );

let props = defineProps( [ "user" ] );

let useCustomPhoto = computed( () => /*(props?.user?.isProf ?? false) ||*/ (props.user?.avatarSource ?? 'avatar') === "photo" );

let userAvatar       = computed( () =>
{

    let avatarUrl;

    // console.log('userAvatar', useCustomPhoto.value,  props.user?.avatarSource ?? 'avatar')

    if ( useCustomPhoto.value )
    {
        // don't worry, the "default" stuff is handled by the model attributes (if no pic)
        avatarUrl = props?.user?.profilePicture ?? '';
    } else
    {
        avatarUrl = (props.user?.avatarProfileUrl ?? '');
    }


    if ( avatarUrl === '' )
    {
        avatarUrl = getDefaultAvatarUrl();
    }



    return avatarUrl;

} );
let userFrame        = computed( () =>
{

    if ( useCustomPhoto.value )
    {
        return '';
    }
    return (props.user?.avatarFrameUrl ?? '') !== '' ? props.user.avatarFrameUrl : getDefaultAvatarFrameUrl();

} );
let userName         = computed( () => props.user?.name ?? 'Utilisateur non-reconnu' );
let frameClass       = computed( () => props.user?.frame?.data?.behind > 0 ? 'frame-behind' : 'frame-in-front' );
let authorIsProf     = computed( () => props.user?.isProf ?? false );
let profClass        = computed( () => authorIsProf.value ? 'is-prof' : 'is-jeune' );
let imageSourceClass = computed( () =>
{
    return "source_" + (authorIsProf.value || (props.user?.avatarSource ?? 'avatar') === "photo" ? "photo" : "avatar");
} );

//methods
async function mounted ()
{
    // console.log( props, copydeck.value.defaultAvatar.fr)
}

onMounted( mounted );


function getDefaultAvatarUrl ()
{

    // console.log("DOES IT EXIST?", copydeck, copydeck.value.avatars)

    if ( typeof copydeck.value.avatars === 'undefined' )
    {
        return '';
    }

    const defaultId = parseInt( copydeck?.value?.defaultAvatarId?.fr ?? 0 );


    const defaultAvatar = copydeck.value.avatars.find( av => av.id === defaultId );
    // console.log( 'defaultAvatar', defaultAvatar, defaultId);

    if ( !defaultAvatar )
    {
        return '';
    }

    return defaultAvatar.profileSizeUrl;
}

function getDefaultAvatarFrameUrl ()
{

    if ( typeof copydeck.value.avatarFrames === 'undefined' )
    {
        return '';
    }

    const defaultId = parseInt( copydeck?.value?.defaultFrameId?.fr ?? 0 );

    const defaultFrame = copydeck.value.avatarFrames.find( avf => avf.id === defaultId );

    // console.log('defaultFrame', defaultFrame);
    if ( !defaultFrame )
    {
        return '';
    }

    return defaultFrame.url;
}


</script>

<style scoped>

</style>
